import { capitalize } from 'lodash';

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { IconBeneficiaryH, IconDepositorH } from 'src/components/Svg/Icons';
import { Table, TableBody, TableCell, TableRow, TableFooter, TableHeader, TableHead } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';

import { useParty } from '../model';

const partyIconMap = {
  [EscrowPartyTypeEnum.Depositor]: IconDepositorH,
  [EscrowPartyTypeEnum.Beneficiary]: IconBeneficiaryH,
};

type Props = {
  escrowInvitation: {
    userName: string;
    userEmail: string;
    companyName: string;
  };
};

const EscrowInvitationCard = ({ escrowInvitation }: Props) => {
  const { type, onEdit } = useParty();

  const Icon = partyIconMap[type];

  return (
    <Card>
      <CardHeader className="relative">
        <CardTitle className="flex items-center gap-2 text-xl">
          <Icon className="size-6" />
          {capitalize(type)} information
        </CardTitle>
        <CardDescription>
          The individual that will be acting as the primary point of contact for the {type} organization.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="rounded-md border border-border grow-1 overflow-hidden h-full">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Company name</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell>{escrowInvitation?.userName}</TableCell>
                <TableCell>{escrowInvitation?.userEmail}</TableCell>
                <TableCell>{escrowInvitation?.companyName}</TableCell>
              </TableRow>
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell colSpan={4}>
                  <div className="flex justify-end">
                    <Button variant="outline" size="sm" onClick={onEdit}>
                      Edit
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};

export default EscrowInvitationCard;
